import React from "react";
import { Helmet } from "react-helmet";
import VolunteerOpportunity from "../../components/VolunteerOpportunity";
import styled from "styled-components";
import dummyImage from "../../assets/images/volunteer/construction.webp";

const Construction = () => {
  const details = `
    We love our construction volunteers! Building homes is what Habitat is all about, and we are so thankful for everyone in Buffalo who is ready to help. Construction volunteers participate in all stages of building or renovating a home.
    
    Do you have some free time and want to lend a helping hand? Individual construction volunteer opportunities are Wednesday – Saturdays. No construction experience is necessary, and no orientation is required. We ask for a full day of commitment when volunteering on our construction sites from 8:00 a.m. to 3:30 p.m. Volunteers must be at least 16 years old (16 & 17 year olds must have a signed minor waiver).
  `;

  const requirements = [
    "Must be at least 16 years old (16 & 17 year olds must have a signed minor waiver).",
    "No construction experience is necessary.",
    "Must commit to a full day of volunteering from 8:00 a.m. to 3:30 p.m.",
  ];

  const workTypes = [
    "Participate in all stages of building or renovating a home",
    "Creating a welcoming environment for all volunteers",
  ];

  const schedule = [
    "Individual construction volunteer opportunities are available Wednesday – Saturdays.",
    "Full day commitment from 8:00 a.m. to 3:30 p.m.",
  ];

  return (
    <>
      <Helmet>
        <title>
          Construction Volunteer Opportunities - Habitat for Humanity Buffalo
        </title>
        <meta
          name="description"
          content="Join Habitat Buffalo as a construction volunteer. Help build homes and communities in Buffalo. No experience necessary."
        />
      </Helmet>
      <Container>
        <VolunteerOpportunity
          title="Construction Volunteer Opportunities"
          image={dummyImage}
          details={details}
          requirements={requirements}
          workTypes={workTypes}
          schedule={schedule}
          ctaTitle="Sign Up to Volunteer"
          ctaDescription="Join us in building homes, communities, and hope. Whether you’re picking up a paintbrush or a hammer, your efforts will make a difference in the lives of Buffalo families."
          ctaButtonText="Sign Up to Volunteer"
          ctaButtonLink="https://habitatbflo.my.site.com/volunteer/s/sign-up?jId=a0T2J00000nmvrtUAA
 "
        />
      </Container>
    </>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
`;

export default Construction;
